module.exports = __webpack_public_path__ + "media/images/site/infantil_brincadeira-55f4c87a79452f833d3753547c1b2812.jpg";